export default {
  allMsg: 'Todos los mensajes',
  systemMsg: 'Mensajes del sistema',
  personMsg: 'Mensajes manuales',
  unread: 'No leído',
  seeDetail: 'Ver detalles',
  read: 'Leído',
  replyNow: 'Responder ahora',
  message: 'Mensaje',
  operateSuccess: 'Operación realizada con éxito',
  holder: {
    searchHolder: 'Número de paquete/Número de pedido/Número de artículo',
  },
  addAcBuy: '¡Únete al Discord de AcBuy y gana ¥2000 en efectivo! ',
  joinNow: 'Únete aquí',
  flatActivity: 'Acbuy Black Friday Sale',
  joinNow1: 'Únete ahora',
  tips1: 'Disfruta de hasta un 70% de descuento',
  tips2: '¡Introduce el código para reclamar tu cupón de envío de ¥110 al instante!',
}
